/* SM WORKS: Produkt-Optionen der Bold-App übersichtlich und auf Deutsch (Thomas 02.11.2026).
   Ändert nur, was der Kunde sieht: Feldnamen (properties[...]) und Werte, die in den Warenkorb gehen, bleiben wie in der App. */
(function () {
  var TITEL = {
    'MOTORCYCLE MODEL': 'Modell', 'MODEL YEAR': 'Baujahr', 'PRODUCTION OPTION': 'Produktion', 'WHEEL SIZE': 'Felgengröße vorne / hinten',
    'RIM COLOR': 'Felgenfarbe', 'RIM COLOR 1': 'Felgenfarbe 1 (obere Hälfte)', 'RIM COLOR 2': 'Felgenfarbe 2 (untere Hälfte)',
    'HUB COLOR': 'Nabenfarbe', 'NIPPLE COLOR': 'Nippelfarbe', 'NIPPLE COLOR 1': 'Nippelfarbe 1', 'NIPPLE COLOR 2': 'Nippelfarbe 2', 'SPOKE COLOR': 'Speichenfarbe',
    'SUPERMOTO TIRE SET': 'Reifensatz montiert', 'TIRE SELECTION': 'Reifen', 'TIRE SETUP': 'Schlauch oder Tubeless',
    'WHEEL BALANCING (RECOMMENDED)': 'Wuchten (empfohlen)', 'WHEEL BALANCING (RECOMMENDED FOR STABLE RIDE AT HIGHER SPEEDS)': 'Wuchten (empfohlen)',
    'PERFORMANCE PARTS': 'Performance Parts', 'FRONT BRAKE SETUP': 'Bremsscheibe vorne', 'BRAKE DISC COLOR': 'Farbe Bremsscheibe', 'ADAPTER COLOR': 'Farbe Adapter',
    'REAR BRAKE SETUP': 'Bremsscheibe hinten', 'SPROCKET SETUP': 'Kettenrad', 'SPROCKET TEETH': 'Zähne Kettenrad', 'SPROCKET COLOR': 'Farbe Kettenrad',
    'MOUNTING HARDWARE': 'Schrauben', 'HUB TYPE': 'Nabentyp', 'HARD FADE': 'Hard Fade', 'SOFT FADE': 'Soft Fade', 'NOTES': 'Anmerkungen',
    'MOTORCYCLE BRAND': 'Marke', 'SMWORKS HUB COLOR': 'Nabenfarbe', 'SM WORKS HUB COLOR': 'Nabenfarbe', 'SMPRO PLATINUM HUB COLOR': 'Nabenfarbe', 'SM PRO PLATINUM HUB COLOR': 'Nabenfarbe', 'HAAN HUB COLOR': 'Nabenfarbe',
    'SMPRO PLATINUM WHEEL SIZE': 'Felgengröße vorne / hinten', 'SM PRO PLATINUM WHEEL SIZE': 'Felgengröße vorne / hinten', 'SMPRO PLATINUM RIM COLOR': 'Felgenfarbe', 'SM PRO PLATINUM RIM COLOR': 'Felgenfarbe',
    'SMPRO PLATINUM CUSHDRIVE HUB': 'Cushdrive-Nabe', 'SM PRO PLATINUM CUSHDRIVE HUB': 'Cushdrive-Nabe'
  };
  var WERT = {
    'STANDARD PRODUCTION': 'Standard', 'EXPRESS PRODUCTION': 'Express', 'YES': 'Ja', 'NO': 'Nein',
    'YES - ADD PERFORMANCE PARTS': 'Ja, Parts dazu', 'NO - WHEELS ONLY': 'Nein, nur Felgen', 'NO UPGRADE': 'Kein Upgrade',
    'HEAVY-DUTY TUBES': 'Heavy-Duty-Schläuche', 'TUBELESS SETUP': 'Tubeless', 'BLACK': 'Schwarz', 'SILVER': 'Silber'
  };
  var HILFE = {
    'ENTER YOUR EXACT MOTORCYCLE MODEL, E.G. 450 EXC-F.': 'Genaues Modell, z. B. 450 EXC-F.',
    'SELECT THE MODEL YEAR OF YOUR MOTORCYCLE.': 'Baujahr deines Motorrads.',
    'EXPRESS: PRIORITY PRODUCTION – SHIPPED WITHIN 4 WEEKS!': 'Express: Vorrang in der Fertigung, Versand innerhalb von 4 Wochen.',
    "FRONT / REAR RIM SIZE. CHECK YOUR MOTORCYCLE'S FITMENT.": 'Prüfe die Freigabe für dein Motorrad.',
    'ADD A COMPLETE FRONT & REAR TIRE SET, MOUNTED ON YOUR WHEELS.': 'Reifen vorne und hinten, fertig auf deine Felgen montiert.',
    'ADD BRAKE DISCS, CALIPER ADAPTER & REAR SPROCKET.': 'Bremsscheiben, Bremszangenadapter und Kettenrad dazu.',
    'SPECIAL REQUESTS OR ADDITIONAL MOTORCYCLE DETAILS? LET US KNOW HERE.': 'Sonderwünsche oder Umbauten an deinem Motorrad? Schreib es hier rein.',
    'SELECT YOUR MOTORCYCLE MANUFACTURER.': 'Hersteller deines Motorrads.',
    'SMPRO PLATINUM FELGEN GRÖSSE VORNE / HINTEN': 'Prüfe die Freigabe für dein Motorrad.',
    'SMPRO PLATINUM RÜCKDÄMPFUNG NABE': 'SM PRO PLATINUM Nabe mit Ruckdämpfung am Hinterrad.'
  };
  // Gruppen: vor dem ersten Feld der Gruppe kommt eine Überschrift
  var GRUPPEN = [
    { name: 'Dein Bike', start: ['MOTORCYCLE BRAND', 'MOTORCYCLE MODEL', 'MODEL YEAR'] },
    { name: 'Felgen-Details', start: ['WHEEL SIZE', 'FRONT RIM SIZE', 'PRODUCTION OPTION', 'SMPRO PLATINUM WHEEL SIZE', 'SM PRO PLATINUM WHEEL SIZE'] },
    { name: 'Deine Farben', start: ['RIM COLOR', 'RIM COLOR 1', 'HARD FADE', 'HUB COLOR', 'SMPRO PLATINUM RIM COLOR', 'SM PRO PLATINUM RIM COLOR'] },
    { name: 'Extras', start: ['SUPERMOTO TIRE SET', 'PERFORMANCE PARTS', 'FRONT BRAKE SETUP'] }
  ];

  // Ja/Nein-Optionen als Schalter-Karten wie die Extras im 3D-Konfigurator (Thomas 02.11.2026); die Radio-Buttons der App bleiben im Formular
  var SVG = function (d) { return '<svg viewBox="0 0 24 24" aria-hidden="true">' + d + '</svg>'; };
  var ICON = {
    blitz: SVG('<path d="M13 2.5 4.5 13.5h6.5l-1 8 8.5-11h-6.5z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>'),
    reifen: SVG('<circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="1.8"/><circle cx="12" cy="12" r="5.2" fill="none" stroke="currentColor" stroke-width="1.6"/><circle cx="12" cy="12" r="1.4" fill="currentColor"/>'),
    scheibe: SVG('<circle cx="12" cy="12" r="8.6" fill="none" stroke="currentColor" stroke-width="1.8"/><circle cx="12" cy="12" r="2.6" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M12 5.2v2M12 16.8v2M5.2 12h2M16.8 12h2M7.2 7.2l1.4 1.4M15.4 15.4l1.4 1.4M16.8 7.2l-1.4 1.4M8.6 15.4l-1.4 1.4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>'),
    waage: SVG('<path d="M12 4v16M7 20h10M5 8h14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="m5 8-2.5 5.5a2.6 2.6 0 0 0 5 0zM19 8l-2.5 5.5a2.6 2.6 0 0 0 5 0z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>')
  };
  var KARTEN = {
    'PRODUCTION OPTION': { t: 'Express-Produktion', d: 'Vorrang in der Fertigung, Versand innerhalb von 4 Wochen.', i: 'blitz' },
    'SUPERMOTO TIRE SET': { t: 'Plug & Play: Reifensatz montiert', d: 'Reifen vorne und hinten, fertig auf deine Felgen montiert.', i: 'reifen' },
    'PERFORMANCE PARTS': { t: 'Performance Parts', d: 'Bremsscheiben, Bremszangenadapter und Kettenrad dazu.', i: 'scheibe' },
    'WHEEL BALANCING (RECOMMENDED)': { t: 'Wuchten', d: 'Empfohlen für ruhigen Lauf bei hohem Tempo.', i: 'waage' },
    'WHEEL BALANCING (RECOMMENDED FOR STABLE RIDE AT HIGHER SPEEDS)': { t: 'Wuchten', d: 'Empfohlen für ruhigen Lauf bei hohem Tempo.', i: 'waage' }
  };
  var istAus = function (v) { return /^(NO\b|STANDARD)/i.test((v || '').trim()); };

  var key = function (t) { return (t || '').replace(/\*/g, '').replace(/\s+/g, ' ').trim().toUpperCase(); };
  // Marke immer „SM WORKS“ und „SM PRO“, auch wenn die App „SMWORKS“ oder „SMPRO“ liefert (Thomas 03.11.2026)
  var marke = function (t) { return (t || '').replace(/\bSM ?WORKS\b/gi, 'SM WORKS').replace(/\bSM ?PRO\b/gi, 'SM PRO'); };
  var farbname = function (t) { return (t || '').toLowerCase().replace(/(^|[\s(\-]+)(\S)/g, function (m, a, b) { return a + b.toUpperCase(); }); };
  var preis = function (t) {
    var m = (t || '').match(/([\d.]+),(\d{2})/);
    if (!m) return t;
    var euro = m[1].replace(/\./g, ''), cent = m[2];
    return '+' + euro + (cent === '00' ? '' : ',' + cent) + '€';
  };

  function titelVon(opt) { var el = opt.querySelector('.bold_option_title'); return el ? (el.getAttribute('data-smw-key') || key(el.textContent)) : ''; }

  function bauen(root) {
    if (root.getAttribute('data-smw') === '1') return;
    root.setAttribute('data-smw', '1');
    root.classList.add('smw-opts');
    uebersetzen(root);
    gruppieren(root);
    aktualisieren(root);
  }

  function uebersetzen(root) {
    root.querySelectorAll('.bold_option_title').forEach(function (el) {
      if (el.getAttribute('data-smw-key')) return;
      var raw = el.textContent, k = key(raw), pflicht = /\*/.test(raw);
      el.setAttribute('data-smw-key', k);
      var de = TITEL[k] || marke(farbname(k));
      el.innerHTML = '';
      el.appendChild(document.createTextNode(de));
      if (pflicht) { var p = document.createElement('span'); p.className = 'smw-opt__pflicht'; p.textContent = '*'; el.appendChild(p); }
      var w = document.createElement('span'); w.className = 'smw-opt__wert'; el.appendChild(w);
    });
    root.querySelectorAll('.bold_help_text small').forEach(function (el) {
      if (el.getAttribute('data-smw')) return;
      el.setAttribute('data-smw', '1');
      var k = el.textContent.replace(/\s+/g, ' ').trim();
      if (HILFE[k]) el.textContent = HILFE[k];
      else el.textContent = marke(k.charAt(0) + k.slice(1).toLowerCase());
    });
    root.querySelectorAll('.bold_option_radio .bold_option_value_title, .bold_option_dropdown option').forEach(function (el) {
      if (el.getAttribute('data-smw')) return;
      el.setAttribute('data-smw', '1');
      var k = key(el.textContent);
      if (WERT[k]) el.textContent = WERT[k];
      else if (k === 'SELECT MODEL YEAR') el.textContent = 'Baujahr wählen';
      else if (/^SELECT/.test(k)) el.textContent = 'Bitte wählen';
      else if (marke(el.textContent) !== el.textContent) el.textContent = marke(el.textContent);
    });
    root.querySelectorAll('.bold_option_value_price').forEach(function (el) {
      if (el.getAttribute('data-smw')) return;
      el.setAttribute('data-smw', '1');
      el.textContent = preis(el.textContent);
    });
    root.querySelectorAll('.bold_option_swatch .bold_option_value label').forEach(function (lab) {
      if (lab.querySelector('.smw-opt__tip')) return;
      var input = lab.querySelector('input[type=checkbox]'), el = lab.querySelector('.bold_option_value_element');
      if (!input || !el) return;
      var tip = document.createElement('span'); tip.className = 'smw-opt__tip';
      var aria = el.getAttribute('aria-label') || '', m = aria.match(/charge of:\s*([^\s]+)/);
      tip.textContent = farbname(input.value) + (m ? ' · ' + preis(m[1]) : '');
      lab.appendChild(tip);
    });
    root.querySelectorAll('input[type=text]').forEach(function (el) { if (!el.placeholder) el.placeholder = 'z. B. 450 EXC-F'; });
  }

  function karten(root) {
    root.querySelectorAll('.bold_option_radio').forEach(function (opt) {
      var def = KARTEN[titelVon(opt)];
      if (!def) return;
      var radios = [].slice.call(opt.querySelectorAll('input[type=radio]'));
      if (radios.length !== 2) return;
      var aus = radios.find(function (r) { return istAus(r.value); }), an = radios.find(function (r) { return r !== aus; });
      if (!aus || !an) return;
      opt.classList.add('smw-opt--karte');
      var karte = opt.querySelector('.smw-karte');
      if (!karte) {
        karte = document.createElement('label');
        karte.className = 'smw-karte';
        karte.innerHTML = '<span class="smw-karte__ico">' + ICON[def.i] + '</span><span class="smw-karte__txt"><b></b><small></small><em></em></span><span class="smw-schalter"><input type="checkbox" role="switch"><span></span></span>';
        var p = an.closest('label') && an.closest('label').querySelector('.bold_option_value_price');
        karte.querySelector('b').textContent = def.t;
        karte.querySelector('small').textContent = def.d;
        karte.querySelector('em').textContent = p ? p.textContent.trim() : '';
        var cb = karte.querySelector('input');
        cb.setAttribute('aria-label', def.t);
        cb.addEventListener('change', function () { var z = cb.checked ? an : aus; (z.closest('label') || z).click(); });
        opt.insertBefore(karte, opt.firstChild);
      }
      karte.querySelector('input').checked = an.checked;
      karte.classList.toggle('ist-an', an.checked);
      if (!an.checked && !aus.checked && !opt.getAttribute('data-smw-start')) {   // wie im Konfigurator: Extras starten aus
        opt.setAttribute('data-smw-start', '1');
        (aus.closest('label') || aus).click();
      }
    });
    // Express-Produktion steht wie im Konfigurator bei den Extras
    var prod = [].find.call(root.querySelectorAll('.bold_option'), function (o) { return titelVon(o) === 'PRODUCTION OPTION'; });
    var extras = [].find.call(root.querySelectorAll('.smw-opt__gruppe'), function (h) { return /extras/i.test(h.textContent); });
    if (prod && extras && extras.nextElementSibling !== prod) { extras.parentNode.insertBefore(prod, extras.nextElementSibling); }
    if (prod) prod.classList.toggle('smw-opt--vorgezogen', !!extras);
  }

  function gruppieren(root) {
    var nr = 0;
    GRUPPEN.forEach(function (g) {
      var opts = [].slice.call(root.querySelectorAll('.bold_option'));
      var ziel = opts.find(function (o) { return g.start.indexOf(titelVon(o)) > -1; });
      var davor = ziel && ziel.previousElementSibling;
      while (davor && (davor.id === 'smw-marke' || davor.classList.contains('smw-opt--vorgezogen'))) davor = davor.previousElementSibling;   // Markenwahl bzw. Express stehen zwischen Überschrift und erstem Feld
      if (!ziel || davor && davor.classList.contains('smw-opt__gruppe')) return;
      nr++;
      var h = document.createElement('h3'); h.className = 'smw-opt__gruppe';
      h.innerHTML = '<span class="smw-opt__nr">' + nr + '</span><span></span>';
      h.lastChild.textContent = g.name;
      ziel.parentNode.insertBefore(h, ziel);
    });
  }

  // Gewählten Wert neben dem Titel zeigen
  function aktualisieren(root) {
    root.querySelectorAll('.bold_option').forEach(function (opt) {
      var w = opt.querySelector('.smw-opt__wert');
      if (!w) return;
      var text = '', plus = '';
      if (opt.classList.contains('bold_option_swatch')) {
        var sel = opt.querySelector('.bold_swatch_selected input[type=checkbox]');
        if (sel) {
          text = farbname(sel.value);
          var m = (sel.closest('.bold_option_value_element').getAttribute('aria-label') || '').match(/charge of:\s*([^\s]+)/);
          if (m) plus = preis(m[1]);
        }
      } else if (opt.classList.contains('bold_option_radio')) {
        var r = opt.querySelector('input[type=radio]:checked');
        if (r) {
          var lab = r.closest('label');
          text = lab.querySelector('.bold_option_value_title').textContent;
          var p = lab.querySelector('.bold_option_value_price'); if (p) plus = p.textContent;
        }
      } else if (opt.classList.contains('bold_option_dropdown')) {
        var s = opt.querySelector('select'); if (s && s.value) text = s.options[s.selectedIndex].textContent;
      }
      w.innerHTML = text ? '· ' + text.replace(/[<>&]/g, '') + (plus ? ' <b>' + plus + '</b>' : '') : '';
    });
  }

  function alle() {
    document.querySelectorAll('.bold_options.bold_options_loaded').forEach(function (root) {
      if (root.getAttribute('data-smw') !== '1') bauen(root);
      else { uebersetzen(root); gruppieren(root); aktualisieren(root); }
      karten(root);   // die App baut Felder neu auf (z. B. Reifen, wenn „Ja“ gewählt)
    });
    document.querySelectorAll('.bold_option_total > div').forEach(function (d) {   // „SELECTED UPGRADES: €30,00 EUR“ -> „Aufpreise: +30€“
      var t = d.firstChild, sp = d.querySelector('span');
      if (t && t.nodeType === 3 && /SELECTED UPGRADES/i.test(t.textContent)) t.textContent = 'Aufpreise: ';
      if (sp && /EUR|€/.test(sp.textContent) && sp.getAttribute('data-smw') !== sp.textContent) { sp.textContent = preis(sp.textContent); sp.setAttribute('data-smw', sp.textContent); }
    });
    gesamt();
    mengeVerschieben();
    markeEinsetzen();
    document.querySelectorAll('.smw-opts').forEach(function (root) {
      root.querySelectorAll('.bold_option_radio').forEach(function (o) {   // lange Texte (Felgengrößen) am Handy über die ganze Breite
        var lang = [].some.call(o.querySelectorAll('.bold_option_value_title'), function (t) { return t.textContent.length > 14; });
        o.classList.toggle('smw-opt--lang', lang);
      });
      root.querySelectorAll('*').forEach(function (el) {
        if (el.children.length === 0 && /^This option is required\.?$/.test((el.textContent || '').trim())) el.textContent = 'Bitte auswählen.';
      });
    });
  }

  // Gesamtpreis über dem Warenkorb-Button: Radsatz-Preis + Aufpreise der App, mal Anzahl (Thomas 02.11.2026)
  var cent = function (t) {
    var m = (t || '').match(/(\d[\d.]*)(?:,(\d{1,2}))?/);
    return m ? parseInt(m[1].replace(/\./g, ''), 10) * 100 + (m[2] ? parseInt((m[2] + '0').slice(0, 2), 10) : 0) : 0;
  };
  var euro = function (c) {
    var e = Math.floor(c / 100), r = c % 100;
    return String(e).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + (r ? ',' + String(r).padStart(2, '0') : '') + '€';
  };
  // Anzahl gehört nicht nach oben, sondern direkt über Preisbox und Warenkorb-Button (unter „Anmerkungen“) (Thomas 02.11.2026)
  function mengeVerschieben() {
    var menge = document.querySelector('.product__info-container .product-form__quantity');
    var knopf = [].find.call(document.querySelectorAll('.product-form__buttons'), function (b) { return b.offsetParent; });
    if (!menge || !knopf) return;
    var ziel = document.querySelector('.smw-gesamt') || knopf;
    if (menge.nextElementSibling !== ziel) ziel.parentNode.insertBefore(menge, ziel);
    menge.classList.add('smw-menge');
  }

  // Was den Aufpreis ausmacht, wie im 3D-Konfigurator (Thomas 03.11.2026). Gelesen wird nur, was gerade sichtbar und gewählt ist.
  var sauber = function (t) { return (t || '').replace(/&/g, '&amp;').replace(/[<>]/g, ' ').replace(/\s+/g, ' ').trim(); };
  function auswahlMitPreis(opt) {
    var k = titelVon(opt), wert = '', c = 0;
    if (opt.classList.contains('bold_option_swatch')) {
      var sel = opt.querySelector('.bold_swatch_selected input[type=checkbox]');
      if (sel) {
        wert = farbname(sel.value);
        var m = (sel.closest('.bold_option_value_element').getAttribute('aria-label') || '').match(/charge of:\s*([^\s]+)/);
        if (m) c = cent(m[1]);
      }
    } else if (opt.classList.contains('bold_option_radio')) {
      var r = opt.querySelector('input[type=radio]:checked');
      if (r) {
        var lab = r.closest('label'), ti = lab && lab.querySelector('.bold_option_value_title'), p = lab && lab.querySelector('.bold_option_value_price');
        wert = ti ? ti.textContent : r.value;
        if (p) c = cent(p.textContent);
      }
    } else if (opt.classList.contains('bold_option_dropdown')) {
      var s = opt.querySelector('select');
      if (s && s.value) {
        var text = s.options[s.selectedIndex].textContent, z = text.match(/\(\+\s*€?\s*([\d.,]+)[^)]*\)\s*$/);
        wert = text.replace(/\s*\(\+[^)]*\)\s*$/, '');
        if (z) c = cent(z[1]);
      }
    }
    if (!c) return null;
    var titel = KARTEN[k] ? KARTEN[k].t : (TITEL[k] || marke(farbname(k)));
    return { name: sauber(/^(ja|yes|express)$/i.test(wert.trim()) || !wert ? titel : titel + ': ' + wert), cent: c };
  }
  function aufpreisListe(auf) {
    if (!auf) return '';
    var summe = 0, zeilen = [];
    document.querySelectorAll('.smw-opts .bold_option').forEach(function (opt) {
      if (!opt.offsetParent) return;
      var a = auswahlMitPreis(opt);
      if (a) { summe += a.cent; zeilen.push(a); }
    });
    if (auf > summe) zeilen.push({ name: 'Weitere Aufpreise', cent: auf - summe });   // die Summe der Liste passt immer zum Aufpreis der App
    return zeilen.length ? '<ul class="smw-gesamt__liste">' + zeilen.map(function (z) { return '<li><span>' + z.name + '</span><b>+' + euro(z.cent) + '</b></li>'; }).join('') + '</ul>' : '';
  }

  // Black Month: eigene grüne Zeile, solange das Gratis-Kit angewählt ist (Thomas 04.11.2026)
  function kitZeile() {
    var b = document.querySelector('[data-smw-bmw]'), an = b && b.querySelector('[data-bmw-an]'), alt = b && b.querySelector('.smw-bmw__preis s');
    if (!an || !an.checked || document.documentElement.classList.contains('smw-bm-kein-rabatt')) return '';
    return '<div class="smw-gesamt__kit"><span>SM PRO KIT</span><s>' + sauber(alt ? alt.textContent : '') + '</s><b>GRATIS</b></div>';
  }

  function gesamt() {
    var daten = document.getElementById('smw-preise');
    var knopf = [].find.call(document.querySelectorAll('.product-form__buttons'), function (b) { return b.offsetParent; });
    if (!daten || !knopf) return;
    var preise; try { preise = JSON.parse(daten.textContent); } catch (e) { return; }
    var form = knopf.closest('form'), idFeld = form && form.querySelector('[name="id"]');
    var basis = idFeld && preise[idFeld.value] != null ? preise[idFeld.value] : preise[Object.keys(preise)[0]];
    var menge = parseInt((document.querySelector('quantity-input input[name="quantity"]') || {}).value, 10) || 1;
    var sp = document.querySelector('.bold_option_total span'), auf = sp ? cent(sp.textContent) : 0;
    var liste = aufpreisListe(auf);
    var box = document.querySelector('.smw-gesamt');
    if (!box) {
      box = document.createElement('div'); box.className = 'smw-gesamt'; box.setAttribute('aria-live', 'polite');
      knopf.parentNode.insertBefore(box, knopf);
    }
    // wie im 3D-Konfigurator: oben Grundpreis bzw. Aufpreis, darunter Gesamtpreis links, Summe rechts
    var html = (auf
        ? '<p class="smw-gesamt__info">Deine Auswahl erhöht den Preis um <b>+' + euro(auf) + '</b><small>Grundpreis ' + euro(basis) + '</small></p>' + liste
        : '<p class="smw-gesamt__info">Grundpreis: <b>' + euro(basis) + '</b></p>') +
      kitZeile() + '<div class="smw-gesamt__zeile"><span>Gesamtpreis' + (menge > 1 ? ' (' + menge + ' Stück)' : '') + '</span><strong>' + euro((basis + auf) * menge) + '</strong></div>';
    if (box.innerHTML !== html) box.innerHTML = html;
  }

  // Markenwahl (snippets/smw-marken-wechsel.liquid) als erstes Feld unter „Dein Bike“ einsetzen; die App baut Felder
  // manchmal neu auf, deshalb wird das Element gemerkt und bei jedem Durchlauf wieder an die richtige Stelle gesetzt
  var markeEl = document.getElementById('smw-marke');
  function markeEinsetzen() {
    if (!markeEl) return;
    var kopf = [].find.call(document.querySelectorAll('.smw-opts .smw-opt__gruppe'), function (h) { return /dein bike/i.test(h.textContent); });
    if (kopf && kopf.nextElementSibling !== markeEl) kopf.parentNode.insertBefore(markeEl, kopf.nextElementSibling);
    markeEl.classList.toggle('smw-marke--drin', !!kopf);
  }

  var plan = null;
  var mo = new MutationObserver(function () { if (plan) return; plan = requestAnimationFrame(function () { plan = null; mo.disconnect(); alle(); beobachten(); }); });
  function beobachten() { mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'aria-checked'] }); }
  document.addEventListener('change', function (e) { if (e.target.closest('.smw-opts')) aktualisieren(e.target.closest('.smw-opts')); });
  document.addEventListener('click', function (e) { var r = e.target.closest('.smw-opts'); if (r) setTimeout(function () { aktualisieren(r); }, 60); });
  document.addEventListener('change', function (e) { if (e.target.name === 'quantity' || e.target.name === 'id') gesamt(); });
  document.addEventListener('click', function (e) { if (e.target.closest('quantity-input')) setTimeout(gesamt, 60); });
  alle();
  beobachten();
})();
